import { useTranslation } from 'react-i18next';
import HelpCard, { HELP_CARD_TYPES } from './HelpCard';
import QueryBoundaries from './QueryBoundaries';
import SrmDetailsCard from './SrmDetailsCard';

const HelpSectionComponent = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className="mb-2 font-bold">{t('helpSection.needHelp')}</p>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-3 lg:gap-6">
        <SrmDetailsCard />
        <HelpCard helpCardType={HELP_CARD_TYPES.HOW_IT_WORKS} />
        <HelpCard helpCardType={HELP_CARD_TYPES.NEED_HELP} />
      </div>
    </>
  );
};

const HelpSection = () => (
  <QueryBoundaries>
    <HelpSectionComponent />
  </QueryBoundaries>
);

export default HelpSection;
